import { useNavigate, useSearchParams } from 'react-router';

import { SignUpDialog } from './SignUpDialog';

/**
 * `/confirm?email=...` — the user has an unconfirmed Cognito account
 * (typically arrived here by trying to sign in and getting
 * `UserNotConfirmedException`, which `/signin` redirects to). The dialog
 * opens directly on the code step; we don't have their password, so on
 * success we send them to `/signin` to log in properly.
 *
 * Without an `email` querystring we route back to `/signup` — the form
 * captures email there.
 */
export function ConfirmPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';

  if (!email) {
    void navigate('/signup', { replace: true });
    return null;
  }

  return (
    <main className="bg-muted/50 min-h-screen">
      <SignUpDialog
        initialStep="code"
        initialEmail={email}
        onComplete={() => {
          void navigate('/signin');
        }}
      />
    </main>
  );
}
